var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27523 6.00029L10.6998 9.42487C11.106 9.83111 11.106 10.4893 10.6998 10.8956C10.2936 11.3019 9.63532 11.3018 9.22907 10.8956L5.80449 7.47103L2.37992 10.8956C1.97367 11.3018 1.31544 11.3018 0.90918 10.8956C0.502923 10.4894 0.502936 9.83113 0.90918 9.42487L4.33376 6.00029L0.90918 2.57572C0.502936 2.16947 0.502936 1.51124 0.90918 1.10498C1.31542 0.698724 1.97366 0.698737 2.37992 1.10498L5.80449 4.52956L9.22907 1.10498C9.63531 0.698737 10.2935 0.698737 10.6998 1.10498C11.1061 1.51123 11.106 2.16946 10.6998 2.57572L7.27523 6.00029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.fb56490d0384b33506f0536c6d8e9fb8.svg";
export { ForwardRef as ReactComponent };